document.addEventListener('DOMContentLoaded', function () {
  function keepPlaying(v) {
    v.muted = true;
    v.playsInline = true;
    v.play().catch(() => {});

    v.addEventListener('pause', function () {
      v.play().catch(() => {});
    });

    v.addEventListener('suspend', function () {
      v.play().catch(() => {});
    });

    document.addEventListener('visibilitychange', function () {
      v.play().catch(() => {});
    });

    new MutationObserver(function () {
      if (v.paused) v.play().catch(() => {});
    }).observe(v, { attributes: true });
  }

  document.querySelectorAll('video[autoplay]').forEach(keepPlaying);
});